import { Anchor, Ruler, MapPin, Navigation, Clock, Check, X } from 'lucide-react';

export default function RequestCard({ request, onViewDetails, onGiveOffer, canGiveOffer = true }) {
  const {
    client,
    boatMake,
    boatLength,
    surveyType,
    message,
    boatType,
    boatYear,
    boatLocation,
    posted,
    claimed,
    id,
  } = request;

  const isClaimed = claimed || request.raw?.accepted_company_id !== null;

  return (
    <div className={`bg-white rounded-xl shadow-sm border ${isClaimed ? 'border-gray-300 opacity-60' : 'border-teal-200 hover:border-teal-400'} transition-all`}>
      <div className="p-4">
        <div className="flex items-start justify-between mb-3">
          <div className="flex items-start gap-3">
            <div className="w-10 h-10 bg-gradient-to-br from-teal-400 to-teal-600 rounded-lg flex items-center justify-center text-white font-bold text-sm">
              {client[0]}
            </div>
            <div>
              <h3 className="font-bold text-gray-900">{client}</h3>
              <p className="text-xs text-gray-600 mt-0.5">{boatMake} {boatLength} • {surveyType}</p>
            </div>
          </div>
          <div className="text-right">
            <span className={`px-2.5 py-1 rounded-full text-xs font-medium ${isClaimed ? 'bg-gray-100 text-gray-600' : 'bg-teal-100 text-teal-700'}`}>
              {isClaimed ? 'Claimed' : 'Available'}
            </span>
            <p className="text-xs text-gray-500 mt-1 flex items-center gap-1 justify-end">
              <Clock className="w-3 h-3" />
              {posted}
            </p>
          </div>
        </div>

        <p className="text-xs text-gray-700 mb-3 line-clamp-2">{message}</p>

        <div className="grid grid-cols-2 gap-3 text-xs mb-3">
          <div className="flex items-center gap-1.5 text-gray-600"><Anchor className="w-3.5 h-3.5" /><span>{boatType} ({boatYear})</span></div>
          <div className="flex items-center gap-1.5 text-gray-600"><Ruler className="w-3.5 h-3.5" /><span>{boatLength}</span></div>
          <div className="flex items-center gap-1.5 text-gray-600"><MapPin className="w-3.5 h-3.5" /><span>{boatLocation}</span></div>
          <div className="flex items-center gap-1.5 text-gray-600"><Navigation className="w-3.5 h-3.5" /><span>{surveyType}</span></div>
        </div>

        <div className="flex items-center justify-between pt-3 border-t border-gray-100">
          {isClaimed ? (
            <div className="flex items-center gap-1.5 text-gray-500 text-xs">
              <X className="w-4 h-4" /> Claimed
            </div>
          ) : (
            <div className="w-full flex justify-end gap-3">
              <button
                onClick={() => onViewDetails(id)}
                className="px-5 py-2.5 bg-gradient-to-r from-teal-500 to-teal-600 text-white rounded-lg text-xs font-bold shadow-sm hover:shadow-md transition-all flex items-center gap-1.5"
              >
                <Check className="w-4 h-4" /> View Details
              </button>

              {canGiveOffer && (
                <button
                  onClick={() => onGiveOffer(id)}
                  className="px-5 py-2.5 bg-gradient-to-r from-emerald-500 to-green-600 text-white rounded-lg text-xs font-bold shadow-sm hover:shadow-md transition-all flex items-center gap-1.5"
                >
                  <Check className="w-4 h-4" /> Give Offer
                </button>
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}